interface SettingsState {
  appType: string | null;
}

export default {
  namespaced: true,

  state: {
    appType: null,
  } as SettingsState,

  getters: {
    isWidget: ({ appType }: SettingsState): boolean => false,
  },

  mutations: {
    mutateAppType(state: SettingsState, appType: string | null): void {
      state.appType = appType;
    },
  },

  actions: {
    setAppType({ commit, state }: { commit: (mutation: string, payload: string | null) => void; state: SettingsState }, appType: string | null): void {
      if (state.appType) {
        return;
      }

      commit('mutateAppType', appType);
    },
  },
};
